import { updateItemInCollection } from "directus/src/operations";

export async function updateBookmarkFolder({ item, projectId }) {
    try {
        const query = {
            fields: [
                "id",
                "bookmark_folder.name",
            ],
        };

        const data = await updateItemInCollection(
            "projects",
            projectId,
            item,
            query
        );

        return data;
    } catch (error) {
        console.error(error);
        throw error;
    }
}
